import React from "react";
import { Form } from "react-bootstrap";

const AppTokenFilters = (props) => {
  const { searchDelay = 750 } = props;

  let delayTimer;

  const handleSearch = (e) => {
    clearTimeout(delayTimer);
    const text = e.target.value;
    delayTimer = setTimeout(() => {
      props.onSearch("search", text);
    }, searchDelay);
  };

  return (
    <>
      {props.onSearch ? (
        <Form.Group>
          <Form.Label htmlFor="search">Search</Form.Label>
          <Form.Control
            type="text"
            placeholder="Search by Degree, and Abbreviation"
            title="Search by Degree, and Abbreviation"
            onChange={(e) => handleSearch(e)}
          />
        </Form.Group>
      ) : null}
    </>
  );
};

export default AppTokenFilters;
